import React from "react";
import { Col } from "react-bootstrap";

const LocalHowItWork = () => {
  return (
    <>
      <Col sm="12" lg="6" xl="6" xxl="5">
        <ul className="vstack gap-4 p-0 list-unstyled">
          <li className="d-flex gap-3">
            <div>
              <svg
                width="35"
                height="34"
                viewBox="0 0 35 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5026 14.1693C20.6322 14.1693 23.1693 11.6322 23.1693 8.5026C23.1693 5.37299 20.6322 2.83594 17.5026 2.83594C14.373 2.83594 11.8359 5.37299 11.8359 8.5026C11.8359 11.6322 14.373 14.1693 17.5026 14.1693Z"
                  fill="#42B5D5"
                />
                <path
                  d="M28.8307 24.7891C28.8307 28.3095 28.8307 31.1641 17.4974 31.1641C6.16406 31.1641 6.16406 28.3095 6.16406 24.7891C6.16406 21.2686 11.2386 18.4141 17.4974 18.4141C23.7562 18.4141 28.8307 21.2686 28.8307 24.7891Z"
                  fill="#42B5D5"
                />
              </svg>
            </div>
            <div>
              <h6 className="pt-2 fs-5 fw-semibold">Create Profile</h6>
              <p className="mb-0">
                Start your journey by creating a profile to unlock and
                experience any destination.
              </p>
            </div>
          </li>
          <li className="d-flex gap-3">
            <div>
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.4445 18.7344C7.31365 18.7344 4.77781 21.2702 4.77781 24.401C4.77781 27.5319 7.31365 30.0677 10.4445 30.0677C13.5753 30.0677 16.1111 27.5319 16.1111 24.401C16.1111 21.2702 13.5753 18.7344 10.4445 18.7344ZM18.9161 20.151V28.651C18.9161 29.4302 19.5536 30.0677 20.3328 30.0677H28.8328C29.612 30.0677 30.2495 29.4302 30.2495 28.651V20.151C30.2495 19.3719 29.612 18.7344 28.8328 18.7344H20.3328C19.5536 18.7344 18.9161 19.3719 18.9161 20.151ZM9.18365 5.37521L4.50865 13.7902C3.98448 14.7394 4.66448 15.901 5.74115 15.901H15.0911C16.1678 15.901 16.8478 14.7394 16.3236 13.7902L11.6486 5.37521C11.526 5.15607 11.3471 4.9736 11.1305 4.84659C10.9139 4.71958 10.6673 4.65262 10.4161 4.65262C10.165 4.65262 9.91844 4.71958 9.7018 4.84659C9.48516 4.9736 9.3063 5.15607 9.18365 5.37521ZM27.7703 3.85938C26.2687 3.85938 25.2062 4.65271 24.5828 5.51688C23.9595 4.65271 22.897 3.85938 21.3953 3.85938C19.1853 3.85938 17.4995 5.67271 17.4995 7.75521C17.4995 10.3477 20.3753 12.246 23.662 15.0935C23.9186 15.313 24.2451 15.4336 24.5828 15.4336C24.9205 15.4336 25.247 15.313 25.5036 15.0935C28.7903 12.246 31.6661 10.3477 31.6661 7.75521C31.6661 5.67271 29.9803 3.85938 27.7703 3.85938Z"
                  fill="#FF872F"
                />
              </svg>
            </div>
            <div>
              <h6 className="pt-2 fs-5 fw-semibold">Add Interests</h6>
              <p className="mb-0">
                Select 10 interests from over 200+ options to personalize your
                adventures.
              </p>
            </div>
          </li>
          <li className="d-flex gap-3">
            <div>
              <svg
                width="35"
                height="34"
                viewBox="0 0 35 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5026 2.83594C25.3269 2.83594 31.6693 9.17835 31.6693 17.0026C31.6693 24.8269 25.3269 31.1693 17.5026 31.1693C9.67835 31.1693 3.33594 24.8269 3.33594 17.0026C3.33594 9.17835 9.67835 2.83594 17.5026 2.83594ZM17.5026 8.5026C17.1269 8.5026 16.7665 8.65186 16.5009 8.91754C16.2352 9.18321 16.0859 9.54355 16.0859 9.91927V17.0026C16.086 17.3783 16.2353 17.7386 16.501 18.0042L20.751 22.2542C21.0182 22.5122 21.3761 22.655 21.7475 22.6518C22.119 22.6486 22.4743 22.4996 22.7369 22.2369C22.9996 21.9743 23.1486 21.619 23.1518 21.2475C23.155 20.8761 23.0122 20.5182 22.7542 20.251L18.9193 16.4161V9.91927C18.9193 9.54355 18.77 9.18321 18.5043 8.91754C18.2387 8.65186 17.8783 8.5026 17.5026 8.5026Z"
                  fill="#768ABB"
                />
              </svg>
            </div>
            <div>
              <h6 className="pt-2 fs-5 fw-semibold">Add Availability</h6>
              <p className="mb-0">
              Experiencers can book you as their host based on shared interests. Add your availability to attract bookings.
              </p>
            </div>
          </li>
          <li className="d-flex gap-3">
            <div>
              <svg
                width="35"
                height="34"
                viewBox="0 0 35 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_4985_55360)">
                  <path
                    d="M25.0109 18.175C26.7285 18.175 28.2837 18.2725 29.2404 18.4543C29.2553 18.4543 30.1307 18.6343 30.4225 18.7504C30.8436 18.9322 31.2001 19.2603 31.4272 19.6708C31.5897 19.999 31.6693 20.3456 31.6693 20.7074C31.6544 21.0843 31.4106 21.7927 31.2962 22.072C30.585 23.9128 28.2506 27.4313 26.8264 28.7808C26.5992 29.0096 26.324 29.257 26.2593 29.3226C25.9012 29.6019 25.4652 29.75 24.996 29.75C24.5732 29.75 24.1521 29.6187 23.8122 29.3546C23.6356 29.2284 23.3779 28.9772 23.2601 28.8596L23.1971 28.7959C21.7215 27.4161 19.5031 23.9785 18.7902 22.2352C18.775 22.2352 18.4199 21.3657 18.348 20.841L18.3359 20.7074V20.6417C18.3359 19.8845 18.7571 19.1778 19.4385 18.816C19.8115 18.6192 20.8958 18.4374 20.9124 18.4206C21.884 18.2725 23.3745 18.175 25.0109 18.175ZM10.0021 18.2616C10.681 18.2616 11.2399 18.7795 11.3163 19.4476L11.3252 19.6043L11.6883 26.0909C11.6883 27.0365 10.9339 27.8021 10.0021 27.8021C9.12857 27.8021 8.40949 27.1292 8.32302 26.2659L8.3143 26.0909L8.67905 19.6043C8.67905 18.8623 9.27095 18.2616 10.0021 18.2616ZM10.0109 4.25C10.4304 4.25 10.8515 4.38125 11.193 4.64373C11.3402 4.74995 11.5437 4.94227 11.6756 5.07157L11.8081 5.20405C13.2821 6.58549 15.5021 10.0214 16.215 11.7646C16.2287 11.7646 16.5851 12.6356 16.6571 13.1605L16.6693 13.2941V13.3597C16.6693 14.1152 16.2465 14.822 15.5667 15.1837C15.1937 15.3823 14.1094 15.5623 14.0928 15.5791C13.1212 15.7272 11.6307 15.8248 9.99431 15.8248C8.27667 15.8248 6.7215 15.7272 5.76485 15.5455C5.74827 15.5455 4.87453 15.3654 4.58273 15.2493C4.1616 15.0693 3.80514 14.7395 3.578 14.3289C3.41552 14.0008 3.33594 13.6542 3.33594 13.2941C3.35086 12.9155 3.59458 12.2088 3.70732 11.9295C4.42024 10.087 6.753 6.56866 8.17885 5.22088C8.40599 4.99036 8.68121 4.74301 8.74587 4.67739C9.10233 4.39807 9.54003 4.25 10.0109 4.25ZM25.0034 6.19792C25.877 6.19792 26.5946 6.87082 26.6809 7.73413L26.6896 7.90919L26.3265 14.3959C26.3265 15.1379 25.7346 15.7386 25.0034 15.7386C24.3245 15.7386 23.7656 15.2207 23.6893 14.5525L23.6804 14.3959L23.3156 7.90919C23.3156 6.96353 24.0717 6.19792 25.0034 6.19792Z"
                    fill="#F1B813"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_4985_55360">
                    <rect
                      width="34"
                      height="34"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div>
              <h6 className="pt-2 fs-5 fw-semibold">Host</h6>
              <p className="mb-0">
              Enjoy sharing your interests with experiencers from around the world and earn income doing what you love — experiencing.
              </p>
            </div>
          </li>
        </ul>
      </Col>
    </>
  );
};

export default LocalHowItWork;
